import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import Logo from './Logo';
import { useT } from '../context/LanguageContext';
import { ui, servicesData } from '../translations';

const Footer = () => {
  const t = useT();

  const quickLinks = [
    { to: '/', label: t(ui.nav.home) },
    { to: '/despre', label: t(ui.nav.about) },
    { to: '/servicii', label: t(ui.nav.services) },
    { to: '/portofoliu', label: t(ui.nav.portfolio) },
    { to: '/contact', label: t(ui.nav.contact) },
  ];

  const featuredServices = servicesData.slice(0, 6);

  return (
    <footer className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Logo variant="dark" />
            <p className="mt-5 text-slate-400 text-sm leading-relaxed">{t(ui.footer.desc)}</p>
            {/* social links removed */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#00BCD4] font-semibold uppercase tracking-widest text-sm mb-5">{t(ui.footer.quickLinks)}</h4>
            <ul className="space-y-3">
              {quickLinks.map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="text-slate-400 text-sm hover:text-white transition-colors duration-200 flex items-center gap-2 group">
                    <span className="w-4 h-px bg-slate-700 group-hover:bg-[#00BCD4] transition-colors duration-200"/>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#00BCD4] font-semibold uppercase tracking-widest text-sm mb-5">{t(ui.footer.servicesTitle)}</h4>
            <ul className="space-y-3">
              {featuredServices.map(s => (
                <li key={s.id}>
                  <Link to="/servicii" className="text-slate-400 text-sm hover:text-white transition-colors duration-200 flex items-center gap-2 group">
                    <span className="w-4 h-px bg-slate-700 group-hover:bg-[#00BCD4] transition-colors duration-200"/>
                    {t(s.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#00BCD4] font-semibold uppercase tracking-widest text-sm mb-5">{t(ui.footer.contactTitle)}</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+40744324272" data-testid="footer-phone"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors duration-200 group">
                  <Phone size={16} className="mt-0.5 text-[#00BCD4] shrink-0"/>
                  <span className="text-sm">+40 744 324 272</span>
                </a>
              </li>
              <li>
                <a href="mailto:office@bee-advised.ro" data-testid="footer-email"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors duration-200">
                  <Mail size={16} className="mt-0.5 text-[#00BCD4] shrink-0"/>
                  <span className="text-sm">office@bee-advised.ro</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin size={16} className="mt-0.5 text-[#00BCD4] shrink-0"/>
                <span className="text-sm">România</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Bee-Advised. {t(ui.footer.rights)}
          </p>
          <p className="text-slate-600 text-xs">
            www.bee-advised.ro
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
